import { getDailyPlanningDetails } from './getDailyPlanningDetails';
import { SCHEDULER_MAP_VIEW_CHANGE, SCHEDULER_MODE_VIEW_TOGGLE, SET_SCHEDULER_MODE } from '../../constants/types';

export function refreshScheduler() {
  return dispatch => {
    dispatch(getDailyPlanningDetails());
  };
}

export function changeSchedulerMapView(isMapView) {
  return {
    type: SCHEDULER_MAP_VIEW_CHANGE,
    isMapView,
  };
}

export function setSchedulerModeView(isNightMode) {
  return {
    type: SET_SCHEDULER_MODE,
    payload: isNightMode,
  };
}

export function toggleSchedulerModeView() {
  return {
    type: SCHEDULER_MODE_VIEW_TOGGLE,
  };
}
